import { mainRoutes } from "@/app/routes";

/**
 * Pilot Seekers stay on Matches / onboarding only — product shell stays in the
 * repo but routing blocks dashboard/network/pathways/etc.
 * Flip to false when the full product shell reopens after the pilot.
 */
export const PILOT_SEEKER_SHELL_GATED = true;

export const PILOT_POST_AUTH_HOME = "/matches";

const GATED_EXACT = new Set<string>([
  ...mainRoutes.map((route) => route.path),
  "/me/access-codes",
  "/design-system",
  "/network/review",
]);

export function postAuthHome(onboardingComplete: boolean, referencesSubmitted = false): string {
  if (!onboardingComplete) return "/onboarding";
  if (!referencesSubmitted) return "/references";
  return PILOT_SEEKER_SHELL_GATED ? PILOT_POST_AUTH_HOME : "/dashboard";
}

export function isPilotGatedProductPath(pathname: string): boolean {
  if (!PILOT_SEEKER_SHELL_GATED) return false;
  if (GATED_EXACT.has(pathname)) return true;
  // Future nested product paths under shell areas.
  return (
    pathname.startsWith("/dashboard") ||
    pathname.startsWith("/network") ||
    pathname.startsWith("/pathways") ||
    pathname.startsWith("/opportunities") ||
    pathname.startsWith("/events") ||
    pathname.startsWith("/profile") ||
    pathname.startsWith("/settings")
  );
}
